import React from 'react';
import { hot } from 'react-hot-loader';
import LogoReplace from '../../../hocs/LogoReplace/LogoReplace';
import { purifier } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ setup, content, attrs = {} }) => {
	const style = {};
	const headingStyle = {};
	const HeadingTag = `h${content?.level || '2'}`;
	let headingClasses = [s.heading];
	if (attrs.className) headingClasses = [...headingClasses, attrs.className.map((cN) => s[`heading${cN}`])];
	if (attrs.align) headingClasses = [...headingClasses, s[`heading__${attrs.align}`]];
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;
	if (attrs.padding) {
		style.padding = attrs.padding.join(' ');
		style.boxSizing = 'border-box';
	}
	if (attrs.fontFamily) headingClasses = [...headingClasses, s[`heading__${attrs.fontFamily}`]];
	if (attrs.fontWeight) headingStyle.fontWeight = parseInt(attrs.fontWeight, 10);
	if (attrs.textTransform) style.textTransform = attrs.textTransform;

	return (
		<div id={urlify(content.rawText)} className={headingClasses.join(' ')} style={style}>
			{
				content.rawText.indexOf('<') !== -1 ? (
					<HeadingTag style={headingStyle} className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, content.rawText)) }} />
				) : (
					<HeadingTag style={headingStyle} className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')}>
						{
							content?.level < 4 ? (
								<LogoReplace str={translate(setup, content.rawText)} />
							) : (
								translate(setup, content.rawText)
							)
						}
					</HeadingTag>
				)
			}
		</div>
	);
};

export default hot(module)(Heading);
